import { render, staticRenderFns } from "./recipePatientInfo.vue?vue&type=template&id=35f1e0c0&scoped=true&"
import script from "./recipePatientInfo.vue?vue&type=script&lang=js&"
export * from "./recipePatientInfo.vue?vue&type=script&lang=js&"
import style0 from "./recipePatientInfo.vue?vue&type=style&index=0&id=35f1e0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1e0c0",
  null
  
)

export default component.exports